import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RadioButtonGroupContext from './RadioButtonGroupContext';
import * as Styled from './RadioButtonGroup.styled';

const RadioButtonGroup = (props) => {
  const {
    children,
    onChange,
    value,
    className,
    classes,
    label,
    labelId,
  } = props;
  return (
    <div
      role="radiogroup"
      aria-labelledby={labelId}
      className={classnames(className, classes.root)}>
      {label && (
        <Styled.GroupLabel id={labelId} className={classes.label}>
          {label}
        </Styled.GroupLabel>
      )}
      <RadioButtonGroupContext.Provider
        value={{
          value,
          onChange,
        }}>
        {children}
      </RadioButtonGroupContext.Provider>
    </div>
  );
};

RadioButtonGroup.Body = Styled.Body;

RadioButtonGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    label: PropTypes.string,
  }),
  label: PropTypes.string,
  labelId: PropTypes.string,
};

RadioButtonGroup.defaultProps = {
  className: '',
  classes: {
    root: '',
    label: '',
  },
  onChange: () => {},
  label: '',
  labelId: '',
};

export default RadioButtonGroup;
